export const TYPES = {
  AureliaLoader: Symbol('AureliaLoader'),
  AureliaLoaderConfig: Symbol('AureliaLoaderConfig'),
};

export interface AureliaLoaderConfig {
  baseUrl: string;
  useCdnUrl: boolean;
  environment?: string;
}

export interface DeferredPromise<T = unknown> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
}

export interface SystemJSConfig {
  baseURL: string;
}

export interface AureliaBootstrap {
  (callback: (aurelia: AureliaInstance) => void): void;
}

export interface AureliaInstance {
  host: Element;
  configModuleId: string | null;
}

export interface AureliaModule {
  configure: (aurelia: AureliaInstance) => void;
}

export interface SystemJS {
  config: (config: SystemJSConfig) => void;
  import: (moduleId: string) => Promise<unknown>;
}

export interface ManifestData {
  appVersion: string;
  [key: string]: unknown;
}

export interface IAureliaLoader {
  loadAureliaLibraries(container: Element): Promise<void>;
  loadManifest(): Promise<ManifestData>;
  generateDeferredPromise<T>(): DeferredPromise<T>;
}

declare global {
  interface Window {
    SystemJS: SystemJS;
  }
}
